import React from "react";

const wrapperStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

const spinnerStyle = {
  width: 40,
  height: 40,
  boxSizing: "border-box",
  border: "4px solid #d4d4d4",
  borderTopColor: "#0a0a0a",
  borderRadius: "50%",
  animation: "route-fallback-spin 550ms linear infinite",
};

// Suspense fallback for lazy-loaded routes. Intentionally dependency-free so
// it adds nothing to the main bundle.
function RouteFallback() {
  return (
    <div style={wrapperStyle}>
      <style>
        {"@keyframes route-fallback-spin { to { transform: rotate(360deg); } }"}
      </style>
      <div style={spinnerStyle} />
    </div>
  );
}

export default RouteFallback;
